<template>
  <nav class="flex justify-center flex-wrap font-display">
    <div
      @click.prevent="toggle"
      class="block lg:hidden">
      <button class="flex items-center px-3 py-2 border rounded text-red-300 border-red-200 hover:text-red-100 hover:border-red-100">
        <svg class="fill-current h-4 w-4" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/></svg>
      </button>
    </div>
    <div
      :class="{'hidden' : isBurgerActive}"
      class="w-full flex-auto lg:flex lg:items-center lg:w-auto">

      <div class="flex flex-col lg:flex-row text-2-3xl tracking-wide font-display items-center lg:justify-center lg:space-x-10 lg:flex-grow">
        <router-link 
          to="/"
          class="mt-4 lg:mt-0 lg:mb-2 text-red-300 hover:text-red-100"
          @click.native="toggle">
          aleksey
        </router-link>
        <router-link
          to="/projects"
          class="mt-4 lg:mt-0 mb-16 lg:mb-2 text-red-300 hover:text-red-100"
          @click.native="toggle">
          projects
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
  export default {
    name: "NavLinks",
    data () {
      return {
        isBurgerActive: true
      }
    },
    methods: {
      toggle() {
        this.isBurgerActive = !this.isBurgerActive
      }
    }
  }
</script>

